(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var _default = {
  id: 'designi-light-theme',
  name: 'Designi Light Theme',
  "default": true,
  mode: 'Light',
  logos: {},
  styles: {
    // eslint-disable-next-line
    "definitions": "definitions",
    fonts: {
      primary: 'Mabry Pro',
      secondary: 'Lato, sans-serif'
    },
    colors: {
      bodyBackgroundColor: '#fff',
      bodyTextColor: '#000',
      bodySecondaryTextColor: '#565656',
      bodyFilledTextColor: '#2A0062',
      primaryFadedColor: '#eee',
      primaryColor: '#2EE8B9',
      primary: '#2EE8B9',
      secondaryColor: '#2A0062',
      errorColor: '#db2828',
      danger: '#db2828',
      error: '#db2828',
      negative: '#db2828',
      background: '#fff',
      white: '#fff',
      anonymous: '#565656',
      plain: '#353535',
      text: '#000',
      headings: '#565656',
      divider: '#f6f6f6',
      backgroundAlternate: '#f6f6f6',
      tertiary: '#565656',
      secondary: '#293440',
      warning: '#f2994a',
      positive: '#2db47d',
      success: '#2db47d'
    },
    // eslint-disable-next-line
    "styles": "styles",
    primary: {
      color: '#0075ff',
      background: '#fff',
      'border-color': '#eee'
    },
    secondary: {
      color: '#293440',
      background: '#f6f6f6'
    },
    'secondary Button.primary': {
      color: '#293440',
      background: '#0ff'
    },
    'Button.primary': {
      color: '#fff',
      background: '#0075ff'
    },
    inverted: {
      color: '#fff',
      background: '#293440'
    },
    'inverted primary': {
      color: '#0ff',
      background: '#293440'
    },
    tertiary: {
      base: {
        color: '#0ff',
        background: '#293440'
      },
      'Button.primary': {
        color: '#0ff',
        background: '#293440'
      }
    },
    'secondary primary': {
      color: '#0ff',
      background: '#293440'
    },
    'secondary secondary': {
      color: '#fff',
      background: '#293440'
    }
  }
};
export default _default; // export default {
//   id: 'designi-light-theme',
//   name: 'Designi Light Theme',
//   default: true,
//   mode: 'Light',
//   logos: {},
//   styles: {
//     primary: {
//       color: '#0075ff',
//       background: '#fff',
//       'border-color': '#eee',
//     },
//     secondary: {
//       color: '#293440',
//       background: '#f6f6f6',
//     },
//     'secondary Button.primary': {
//       color: '#293440',
//       background: '#0ff',
//     },
//     'Button.primary': {
//       color: '#fff',
//       background: '#0075ff',
//     },
//     inverted: {
//       color: '#fff',
//       background: '#293440',
//     },
//     'inverted primary': {
//       color: '#0ff',
//       background: '#293440',
//     },
//     tertiary: {
//       base: {
//         color: '#0ff',
//         background: '#293440',
//       },
//       'Button.primary': {
//         color: '#0ff',
//         background: '#293440',
//       },
//     },
//     'secondary primary': {
//       color: '#0ff',
//       background: '#293440',
//     },
//     'secondary secondary': {
//       color: '#fff',
//       background: '#293440',
//     },
//   },
// };

;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/themes/light.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();